import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify'
import { initializeFirebase } from './firebase_config' // ✅ Replace default import
import Firebase from 'firebase/app'
import moment from 'moment-timezone'
import VueCurrencyFilter from 'vue-currency-filter'
import _ from 'lodash'
import '@/assets/css/alertify.css'

Object.defineProperty(Vue.prototype, '$_', { value: _ })
moment.tz.setDefault('America/New_York')

Vue.config.productionTip = false

Vue.use(VueCurrencyFilter, {
  symbol: '$',
  thousandsSeparator: ',',
  fractionCount: 2,
  fractionSeparator: '.',
  symbolPosition: 'front',
  symbolSpacing: true
})

// ✅ Wait until Firebase is initialized before mounting the app
initializeFirebase().then(() => {
  new Vue({
    router,
    store,
    vuetify,
    render: h => h(App)
  }).$mount('#app')
}).catch(err => {
  console.error('🔥 Firebase failed to initialize:', err)
})
